/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable no-console */
import { IImportHandler } from '../import-handler.interface';
import { ColumnRepository, TableRepository, WorkspaceDatabaseKeys } from '@database/workspace';
import { ErrorCodes, FileModel, ToastDuration, ToastService } from '@shared';
import { LoggingService } from '@shared/logging';
import { TableInfoModel, TableInfoRepository, TableTypeEnum, WorkspaceRepository } from '@database/central';
import { TranslateService } from '@ngx-translate/core';

export class ConfigDatabaseDataImporterHandler implements IImportHandler {
	private next: IImportHandler;

	public constructor(
		private columnRepository: ColumnRepository,
		private tableRepository: TableRepository,
		private loggingService: LoggingService,
		private toastService: ToastService,
		private translateService: TranslateService,
		private tableInfoRepository: TableInfoRepository,
		private workspaceRepository: WorkspaceRepository
	) {}

	public async cleanup(model: FileModel): Promise<void> {
		await this.workspaceRepository.remove(model.workFileId);
	}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel) {
		try {
			await Promise.all([
				this.columnRepository.bulkInsert(model.FusionDataColumns),
				this.tableRepository.bulkInsert(model.FusionDataTables),
				this.tableInfoRepository.bulkInsert(
					model.FusionDataTables.filter(
						(item) => !WorkspaceDatabaseKeys.excludedItems.includes(item.table_name.toUpperCase())
					).map(
						(table) =>
							new TableInfoModel({
								name: table.table_name,
								tableType: TableTypeEnum.DataTable,
								workFileId: model.workFileId
							})
					)
				)
			]);
			
		} catch (error) {
			await this.toastService.presentError(
				this.translateService.instant('importPage.messages.importError'),
				ToastDuration.Slow
			);

			this.loggingService.error(ErrorCodes.ConfigDatabaseDataImporterHandler, error);
			await this.cleanup(model);
			throw error;
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}
}
